<template>
    <div class="c-practice-mode"
        :class="modeClass">
        <div class="c-practice-mode__icon"></div>
        <div class="wr-practice-mode-content">
            <span class="c-practice-mode__label">PRATİK MODU</span>
            <span class="c-practice-mode__name">{{ modeName }}</span>
            <span class="c-practice-mode__desc">{{ modeDesc }}</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            modeId:     { type: Number, default: 0 },
            modeType:   { type: String, default: 'lorem_type' },
            modeSlug:   { type: String, default: 'lorem-slug' },
            modeName:   { type: String, default: 'Lorem' },
            modeDesc:   { type: String, default: 'Lorem ipsum dolor sit amet.' },
        },

        computed: {
            modeClass(){
                return `c-practice-mode--${this.modeSlug}`;
            }
        }
    };
</script>

<style scoped src="@/css/components/c-practice-mode.css"></style>